import Swal from 'sweetalert2';

export const handleFileChange = (e, setFileInputs) => {
  const newFiles = Array.from(e.target.files);
  // Ajouter les nouveaux fichiers à la liste existante
  setFileInputs(prevFiles => [...prevFiles, ...newFiles]);
  // Réinitialiser l'input pour permettre de sélectionner les mêmes fichiers à nouveau
  e.target.value = '';
};

export const handlePreview = (files) => {
  if (files && files.length > 0) {
    const file = files[0]; // On prévisualise le premier fichier
    if (file.type.startsWith('image/')) {
      const reader = new FileReader();
      reader.onloadend = () => {
        Swal.fire({
          imageUrl: reader.result,
          imageAlt: 'Prévisualisation du justificatif',
          showCloseButton: true,
          showConfirmButton: false,
          customClass: {
            popup: 'custom-swal-popup',
            image: 'custom-swal-image'
          }
        });
      };
      reader.readAsDataURL(file);
    } else {
      window.open(URL.createObjectURL(file), '_blank');
    }
  }
};

export const handlePreviewExisting = (filePath) => {
  const ext = filePath.split('.').pop().toLowerCase();
  
  // Construire l'URL correcte selon le format du chemin
  let imageUrl;
  if (filePath.startsWith('uploads/')) {
    // Le chemin contient déjà uploads/, utiliser tel quel
    imageUrl = `/${filePath}`;
  } else if (filePath.includes('/')) {
    // C'est un chemin complet, utiliser tel quel
    imageUrl = `/${filePath}`;
  } else {
    // C'est juste un nom de fichier, ajouter uploads/
    imageUrl = `/uploads/${filePath}`;
  }
  
  
  if (["jpg","jpeg","png","gif","bmp","webp"].includes(ext)) {
    // Gérer les erreurs d'image directement via l'événement onerror
    const img = new Image();
    img.onload = () => {
      // L'image se charge correctement, afficher SweetAlert
      Swal.fire({
        imageUrl: imageUrl,
        imageAlt: 'Prévisualisation du justificatif',
        showCloseButton: true,
        showConfirmButton: false,
        customClass: {
          popup: 'custom-swal-popup',
          image: 'custom-swal-image'
        }
      });
    };
    img.onerror = () => {
      console.error('Erreur lors du chargement de l\'image:', imageUrl);
      Swal.fire({
        icon: 'error',
        title: 'Erreur',
        text: 'Impossible de charger l\'image. Vérifiez que le fichier existe.',
        confirmButtonText: 'OK'
      });
    };
    img.src = imageUrl;
  } else {
    window.open(imageUrl, '_blank');
  }
};

export const handleRemoveExistingFile = (idx, setExistingFiles) => {
  setExistingFiles(prev => prev.filter((_, i) => i !== idx));
}; 